export const SHIELD_BREAK_EVENT = 'shield-break'
